import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleAIActCybersecurite() {
  return (
    <BlogArticleLayout
      tag="IA & Cybersécurité"
      title="AI Act et cybersécurité : ce que ça change pour votre entreprise"
      date="26 novembre 2026"
      ctaTitle="Anticipez vos obligations AI Act"
      ctaText="Le diagnostic vous aide à situer votre niveau de préparation face aux exigences croisées de l'AI Act et de votre cybersécurité globale."
    >
      <p style={s.intro}>
        L'AI Act, le règlement européen sur l'intelligence artificielle, introduit un nouveau texte à
        connaître pour toute entreprise qui utilise ou développe des systèmes d'IA. Contrairement au RGPD ou
        à NIS2, il ne porte pas directement sur la sécurité de vos données ou de vos réseaux, mais sur les
        systèmes d'IA eux-mêmes et leurs usages.
      </p>

      <h2 style={s.h2}>Une approche par niveau de risque</h2>
      <p>
        L'AI Act classe les systèmes d'IA selon leur niveau de risque : inacceptable (interdit), élevé
        (fortement encadré), limité (obligations de transparence) et minimal (peu ou pas d'obligations
        spécifiques). La majorité des usages d'IA générique en entreprise (assistance à la rédaction,
        support client) relève d'un risque limité ou minimal, mais certains usages spécifiques — recrutement,
        évaluation de crédit, surveillance — peuvent basculer en risque élevé.
      </p>

      <h2 style={s.h2}>Le lien avec la cybersécurité</h2>
      <p>
        Pour les systèmes d'IA à risque élevé, l'AI Act impose des exigences qui recoupent directement des
        principes de cybersécurité : robustesse technique, gestion des risques tout au long du cycle de vie
        du système, qualité et gouvernance des données utilisées, et documentation technique. C'est cette
        proximité qui justifie de traiter l'AI Act aux côtés de vos autres référentiels de conformité, plutôt
        qu'isolément.
      </p>

      <h2 style={s.h2}>Ce que cela signifie concrètement pour une PME</h2>
      <p>
        La plupart des PME ne développent pas leurs propres systèmes d'IA à haut risque : elles en sont
        utilisatrices, via des outils tiers. Dans ce cas, l'enjeu principal est de s'assurer que les
        fournisseurs utilisés respectent eux-mêmes leurs obligations, et de documenter vos propres usages pour
        pouvoir démontrer, le cas échéant, votre niveau de diligence.
      </p>

      <h2 style={s.h2}>AI Act, RGPD, NIS2 : des textes qui se complètent</h2>
      <p>
        L'AI Act ne remplace ni le RGPD ni NIS2 : il s'ajoute à un paysage réglementaire déjà présent pour
        toute entreprise qui traite des données personnelles ou opère dans un secteur critique. Voir notre
        article
        {' '}<Link to="/blog/ia-rgpd-nis2-articuler" style={s.link}>IA, RGPD, NIS2 : comment articuler les trois exigences</Link>{' '}
        pour une vue d'ensemble de ces interactions.
      </p>

      <p style={s.disclaimer}>
        Cet article a une vocation informative. Le classement précis d'un système d'IA au regard de l'AI Act
        dépend de son usage exact : en cas de doute, faites valider votre analyse par un professionnel du
        droit spécialisé.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleAIActCybersecurite;
